export default function editFundItOptions(postData) {
  // console.info(postData);

  // {
  //   "signupListItemID": 18,
  //   "hasSignupCost": true,
  //   "costType": "PerItem"
  //   "amount": 1234 // amount in cents
  // }

  return {
    success: true,
  };
}
